import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'discountPrice'
})
export class DiscountPricePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    let promocodeDiscount = args[0] && args[0]['amount'] ? parseInt(args[0]['amount'], 10) : 0;
    let passCount = args[1] ? args[1] : 1;
    const RETAIL_PRICING = 1,
      DISCOUNT_PRICING = 2,
      BOGO_PRICING = 3,
      FREE_GUEST_PRICING = 4,
      DROPIN_PRICING = 5;
      switch (value.pricing_type_id) {
          case RETAIL_PRICING:
          case DISCOUNT_PRICING:
          case BOGO_PRICING:
              return this.maybeFree(Math.max(0,value.total_amount*passCount - promocodeDiscount));
          case FREE_GUEST_PRICING:
              return this.maybeFree(0);
          case DROPIN_PRICING:
              return this.maybeFree(Math.max(0,value.dropin_value*passCount - promocodeDiscount));
      }

      return '';
  }

  maybeFree(price) {
    return (price === 0) ? 'Free/By Donation' : this.getCurrency(price, 0, false);
  }
  getCurrency(val, digits, forceZero) {
    const PREFIX  = '$',
    POSTFIX = ' CAD',
    FREE    = 'FREE';
    const num = Number(val),
        fixed = digits ? digits : 2;
    if (val) {
      return PREFIX + num.toFixed(fixed) + POSTFIX;
    } else {
      return forceZero ? PREFIX + Number(0).toFixed(fixed) + POSTFIX : FREE;
    }
  }
}
